// UrlQueryLoader.jsx
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { NULL_FUNCTION } from '../resource/defaults.js';

export const UrlQueryLoader = ({ loadUrlQuery = NULL_FUNCTION }) => {
  const { search } = useLocation();
  useEffect(() => {
    const loadURLQuery = () => {
      const searchParams = new URLSearchParams(search);
      loadUrlQuery({ searchParams });
    };

    loadURLQuery();
  }, [search, loadUrlQuery]);

  return null;
};

UrlQueryLoader.propTypes = {
  loadUrlQuery: PropTypes.func,
};

export default UrlQueryLoader;
